import { LOG_ERROR, DISMISS_NOTIFICATION } from "../actions";
import initialState from "./initialState";
import uuid from "../utils/uuid";
export default function errors() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState.errors, action = arguments.length > 1 ? arguments[1] : void 0;
    var newState = state.slice();
    switch(action.type){
        case LOG_ERROR:
            var _e = {
                id: uuid(),
                timestamp: new Date(),
                seen: false,
                error: action.error
            };
            if (action.key) {
                _e.key = action.key;
            }
            if (action.error.message) {
                newState.push(_e);
            }
            return newState;
        case DISMISS_NOTIFICATION:
            var n = newState.find(function(_n) {
                return _n.id === action.id;
            });
            if (n) {
                n.seen = true;
            }
            return n ? newState : state;
        default:
            return state;
    }
}
